module.exports = __webpack_public_path__ + "static/media/bancolombia-ico-ofertas-02.f51c958b.svg";